import { Storybook } from "@tento-ui/ui/storybook";
import { EventTooltip, EventTooltipLine } from "@tento-lona/sheets-ui";
import { DateTime } from "@tento-chrono";
import { type EventCategory } from "@tento-lona";
import { AuthId, CalendarEvent, CalendarId, EventId, EventItem, EventOrigin, RowLocalId } from "@tento-lona/sheets";
import { STORYBOOK_EVENT_PRESENTATION } from "../storybook-presentation";

// Event color is now derived from the event's category (via
// EventItemPresentation.backgroundColor → EventCategoryItem color), so the storybook
// builds real events with varied categories rather than stub objects carrying
// a `backgroundColor` field.
const ORIGIN = EventOrigin.backingRow(
  new RowLocalId.Registry().resolveFromRawId("storybook-mock"),
);

let mockSeq = 0;

function mockEvent(title: string, category: EventCategory): EventItem {
  return EventItem.make(
    CalendarEvent.of({
      id: EventId.of(`mock-${category}-${mockSeq++}`),
      title,
      start: DateTime.utc.now(),
      end: DateTime.utc.now(),
      authId: AuthId.of("mock"),
      calendarId: CalendarId.of("mock"),
      category,
    }),
    null,
    ORIGIN,
  );
}

export class EventTooltipStoryBook extends Storybook.Default {
  title(): string {
    return "Event Tooltip";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Single Event",
        render: () => {
          const $tooltip = EventTooltip.make();
          $tooltip.bind([mockEvent("Team Meeting", "work")], STORYBOOK_EVENT_PRESENTATION);
          return $tooltip;
        },
      },
      {
        title: "Multiple Events",
        render: () => {
          const $tooltip = EventTooltip.make();
          $tooltip.bind([
            mockEvent("Morning Standup", "work"),
            mockEvent("Lunch with Client", "food"),
            mockEvent("Project Review", "social"),
          ], STORYBOOK_EVENT_PRESENTATION);
          return $tooltip;
        },
      },
      {
        title: "Many Events",
        render: () => {
          const $tooltip = EventTooltip.make();
          $tooltip.bind([
            mockEvent("Early Coffee", "food"),
            mockEvent("Gym Session", "exercise"),
            mockEvent("Doctor Appointment", "errands"),
            mockEvent("Team Sync", "work"),
            mockEvent("Evening Run", "exercise"),
          ], STORYBOOK_EVENT_PRESENTATION);
          return $tooltip;
        },
      },
      {
        title: "Single Row",
        render: () => {
          return EventTooltipLine.makeWith(
            mockEvent("Individual Row Item", "errands"),
            STORYBOOK_EVENT_PRESENTATION,
          );
        },
      },
    ];
  }
}
